export function getServiceDropdownOptions(serviceValues) {
    return serviceValues.data.map(value => {
        return {label: value.name, value: value.index}
    });
}

export const BULK_UPLOAD_ROWS_PER_CALL = 100;

function splitCsvRows(csvContents) {
    const rows = [];
    let current = '';
    let inQuotes = false;
    for (let i = 0; i < csvContents.length; i++) {
        const char = csvContents[i];
        if (char === '"') {
            if (inQuotes && csvContents[i + 1] === '"') {
                current += '""';
                i++;
                continue;
            }
            inQuotes = !inQuotes;
            current += char;
            continue;
        }
        if (!inQuotes && (char === '\n' || char === '\r')) {
            rows.push(current);
            current = '';
            if (char === '\r' && csvContents[i + 1] === '\n') {
                i++;
            }
            continue;
        }
        current += char;
    }
    rows.push(current);
    return rows;
}

export function splitCsvIntoChunks(csvContents, chunkSize = BULK_UPLOAD_ROWS_PER_CALL) {
    if (!csvContents) {
        return [];
    }
    const [header, ...dataRows] = splitCsvRows(csvContents);
    const rowsToKeep = dataRows.filter(row => row.trim() !== '');

    const chunks = [];
    for (let i = 0; i < rowsToKeep.length; i += chunkSize) {
        const chunkRows = rowsToKeep.slice(i, i + chunkSize);
        chunks.push({
            data: [header, ...chunkRows].join('\n'),
            firstRow: i + 1,
            lastRow: i + chunkRows.length,
        });
    }
    return chunks;
}

export function describeRowRange({firstRow, lastRow}) {
    return firstRow === lastRow ? `row ${firstRow}` : `rows ${firstRow}-${lastRow}`;
}

